import "./AICanvasMessage.css";
import { AgentCanvasResponseToolbar } from "./AgentCanvasResponseToolbar";
import { useMessageThreadInfo } from "../../hooks/useMessageThreadInfo";
import { AIResponseCanvasMessage } from "winslow-core";
import { useRef, useEffect, useState } from "react";

import { ThreadInfo } from "./ThreadInfo";
import { marked } from "marked";

type AICanvasMessageProps = {
  message: AIResponseCanvasMessage;
  onExpand: (message: AIResponseCanvasMessage) => void;
  onEditInDocument?: (message: AIResponseCanvasMessage) => void;
};

export const AICanvasMessage = ({
  message,
  onExpand,
  onEditInDocument,
}: AICanvasMessageProps) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const contextInfo = useMessageThreadInfo(message.thread);
  const { title, content } = message.message;

  const handleExpand = () => {
    onExpand(message);
  };

  const handlePreviewClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onExpand(message);
  };

  return (
    <>
      <div className="agent-chat-history-prompt-response">
        <div
          className={`agent-chat-history-prompt-response-object canvas-message`}
          onClick={handleExpand}>
          <div className="agent-chat-history-general">
            <div
              className="agent-chat-q-and-a-preview"
              onClick={handlePreviewClick}>
              {/* Canvas Message Title */}
              <div className="canvas-message-title">
                <h3>{title}</h3>
              </div>
              <div
                ref={contentRef}
                className="agent-chat-q-and-a-preview-content canvas-message-content"
                dangerouslySetInnerHTML={{
                  __html: marked(content) as string,
                }}
              />
            </div>
          </div>
        </div>

        <div className="agent-chat-history-item-toolbar">
          <AgentCanvasResponseToolbar
            key={`toolbar-${message.id}`}
            message={message}
            onEditInDocument={onEditInDocument}
          />
          {contextInfo && (
            //the persona that is selected for the thread
            <ThreadInfo
              showAvatar={true}
              avatar={contextInfo.avatar}
              label={contextInfo.label}
            />
          )}
        </div>
      </div>
    </>
  );
};
